import { render, staticRenderFns } from "./AboutUsingDataListParts.vue?vue&type=template&id=61e43e89&scoped=true"
import script from "./AboutUsingDataListParts.vue?vue&type=script&lang=ts"
export * from "./AboutUsingDataListParts.vue?vue&type=script&lang=ts"
import style0 from "./AboutUsingDataListParts.vue?vue&type=style&index=0&id=61e43e89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e43e89",
  null
  
)

export default component.exports